export default "__VITE_ASSET__CCQ5rqHT__"